import { TbHealthRecognition } from 'react-icons/tb'
import { FaRobot } from 'react-icons/fa'
import { MdLocalHospital } from 'react-icons/md'

const Projects = () => {
    return (
        <section id="projects" className="px-6 md:px-28 py-24">
            <div className="flex">
                <div className="bg-primary h-9 w-2 mr-3" />
                <p className="text-4xl font-bold">Projects</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-12">
                <a
                    href="https://lanepact.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-12 rounded-md bg-center relative bg-cover overflow-hidden h-96 hover:cursor-pointer md:h-72"
                    style={{
                        backgroundImage: `url(${'pexels-tara-winstead-8386440.jpg'})`,
                    }}
                >
                    <div class="absolute bottom-0 left-0 right-0 p-12 h-full w-full overflow-hidden bg-fixed portfolio-one">
                        <div className="mb-2">
                            <FaRobot className="w-12 h-12 self-center text-white" />
                        </div>
                        <div>
                            <p className="text-3xl text-white font-bold heading py-2">
                                Lanepact
                            </p>
                            <p className="max-w-lg text-sm text-white py-2">
                                Lanepact is a no-code platform that allows you
                                to create and build custom applications and
                                portfolios without writing a single line of code
                                by leveraging the power of AI.
                            </p>

                            <code className="text-white text-sm">
                                Backend || Nest.js, MongoDB, Docker, AWS
                            </code>
                        </div>
                    </div>
                </a>
                <a
                    href="https://frootify.tech/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-12 rounded-md bg-center relative bg-cover overflow-hidden h-96 hover:cursor-pointer md:h-72"
                    style={{
                        backgroundImage: `url(${'pexels-guilhermealmeida-1858175.jpg'})`,
                    }}
                >
                    <div class="absolute bottom-0 left-0 right-0 p-12 h-full w-full overflow-hidden bg-fixed portfolio-seven">
                        <div className="mb-2">
                            <TbHealthRecognition className="w-12 h-12 self-center text-white" />
                        </div>
                        <div>
                            <p className="text-3xl text-white font-bold heading py-2">
                                Frootify
                            </p>
                            <p className="max-w-lg text-sm text-white py-2">
                                Frootify is a preventive healthcare startup that
                                aims to democratize access to health data and
                                preventive health services to anyone, anywhere,
                                anytime.
                            </p>

                            <code className="text-white text-sm">
                                Frontend || React, Tailwind
                            </code>
                        </div>
                    </div>
                </a>
                <a
                    href="https://healthstack.africa/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-12 rounded-md bg-center relative bg-cover overflow-hidden h-96 hover:cursor-pointer md:h-72"
                    style={{
                        backgroundImage: `url(${'pexels-negative-space-34577.jpg'})`,
                    }}
                >
                    <div class="absolute bottom-0 left-0 right-0 p-12 h-full w-full overflow-hidden bg-fixed portfolio-six">
                        <div className="mb-2">
                            <MdLocalHospital className="w-12 h-12 self-center text-white" />
                        </div>
                        <div>
                            <p className="text-3xl text-white font-bold heading py-2">
                                Healthstack
                            </p>
                            <p className="max-w-lg text-sm text-white py-2">
                                A hospital management system that allows
                                physicians to manage patients and their records,
                                appointments, and billing.
                            </p>

                            <code className="text-white text-sm">
                                Fullstack || Nodejs, MongoDB , Feathers.js ,
                                Reactjs , MaterialUI
                            </code>
                        </div>
                    </div>
                </a>
            </div>
        </section>
    )
}

export default Projects
